import Header from "./Header";
import Sidebar from "./Sidebar";
import { ReactNode } from "react";
import { ErrorProvider } from "context/ErrorContext";
import { useNavigate } from "react-router-dom";
import * as React from "react";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";

import { SvgIcon } from "@mui/material";

const drawerWidth = "16.937rem";

interface IMainLayout {
  children: ReactNode;
}

export const Layout = ({ children }: IMainLayout) => {
  const navigate = useNavigate();

  //  const me = useAppSelector((state: any) => state.userLoggedState.user);


  return (
    <ErrorProvider>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Header />
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          {drawerWidth && (
            <Drawer
              variant="permanent"
              sx={{
                display: { xs: "none", sm: "block" },
                "& .MuiDrawer-paper": {
                  marginTop: "6rem",
                  boxSizing: "border-box",
                  width: drawerWidth,
                  backgroundColor: "#FFF",
                  boxShadow: "0px 6px 15px 2px #0000000D",
                  border: "none",
                  borderRadius: "0 0.938rem 0.938rem 0",
                  height: "calc(100% - 6rem)",
                },
              }}
              open
            >
              <Sidebar />
            </Drawer>
          )}
        </Box>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            paddingTop: 0,
            width: { sm: `calc(100% - ${drawerWidth})` },
            marginTop: "6rem",
          }}
        >
          {children}
        </Box>
      </Box>
    </ErrorProvider>
  );
};
